import { getMessageFromStore } from '@/features/chats/model/conversation/selectors';
import { getMessageFromSDK } from '@/infrastructure/sdk/message';
import { logger } from '@/shared/utils';

/**
 * Resolve a message by ID via 2-tier lookup: Redux → SDK.
 *
 * @param {string} msgId
 * @param {string} chatId   - Plain user/group ID (used for Redux + JID fallback)
 * @param {string} chatJid  - Full JID (used for SDK call; falls back to `${chatId}@xmpp`)
 * @returns {Promise<Object|null>}
 */
export const resolveMessageById = async (msgId, chatId, chatJid) => {
   const reduxMsg = getMessageFromStore(chatId, msgId);
   if (reduxMsg) return reduxMsg;

   try {
      const sdkRes = await getMessageFromSDK(msgId, chatJid);
      if (sdkRes?.statusCode === 200 && sdkRes?.data) {
         return sdkRes.data;
      } else {
         logger.error(`[resolveMessageById] SDK fetch failed for ${msgId}, ${chatId}, ${chatJid}. Response:`, sdkRes);
      }
   } catch (err) {
      logger.error(`[resolveMessageById] SDK fetch failed for ${msgId}:`, err);
   }

   return null;
};
